module.exports = __webpack_public_path__ + "static/media/eve-uni.83e0fe48.svg";